// extracted by mini-css-extract-plugin
export default {"main":"PageWrapper_main__HvQMC"};